import createReducer from 'state/reducerHelper';
import { isLoadingDataState, dataSourceFailure } from 'state/utils';
import * as types from './types';

const featuresReducer = createReducer({ isFetching: true })({
  [`${types.GET_FEATURES}_PENDING`]: isLoadingDataState,
  [`${types.GET_FEATURES}_REJECTED`]: dataSourceFailure,
  [`${types.GET_FEATURES}_FULFILLED`]: (state, { payload }) => {
    const featuresMap = {};
    payload.forEach(f => {
      featuresMap[f.feature] = f;
    });
    return featuresMap;
  },
});

export default featuresReducer;



// WEBPACK FOOTER //
// ./src/state/reducers/team/teamFeatureReducers.js